<template>
  <div>
    <footer
      id="footer"
      v-if="
        getCurrentPath === '/' ||
        getCurrentPath === '/callenglish' ||
        getCurrentPath === '/edu-tech' ||
        getCurrentPath === '/imooc' ||
        getCurrentPath === '/aitutor' ||
        getCurrentPath === '/custom-cont' ||
        getCurrentPath == !'https://expatcare.co.kr/'
      "
    >
      <div class="inner">
        <div class="left">
          <p>당근영어 원격평생교육시설</p>
          <p>
            (주)캐럿솔루션즈 | 서울특별시 서초구 강남대로 479 신논현타워 6F
            06541 | <a @click="showPopup('privacy')">개인정보처리방침</a> |
            <a @click="showPopup('terms')">회원약관</a>
          </p>
          <p>
            대표이사 이은경 Copyright ⓒCARROT Solutions Inc. All rights
            reserved.
          </p>
          <p>
            사업자 등록번호 357-87-02040
            <a
              href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=3578702040"
              target="_blank"
              >사업자등록번호확인</a
            >
            | 통신판매업 신고번호 제 2021-서울강남-05384호 | 대표번호 :
            02-518-0036
          </p>
          <p>
            이메일 helpcarrot@carrotglobal.com | 호스팅제공자 : (주)엘지유플러스
            KIDC | 개인정보관리책임자 김범진
          </p>
        </div>
        <div class="right">
          <div class="sns">
            <p>FOLLOW US :</p>
            <ul>
              <li>
                <a @click="newPage('https://www.instagram.com/carrotglobal')"
                  ><img src="@/assets/img/sns1.png" alt="인스타그램"
                /></a>
              </li>
              <li>
                <a
                  @click="
                    newPage(
                      'https://www.facebook.com/people/Carrot-Farm/100014542383160'
                    )
                  "
                  ><img src="@/assets/img/sns2.png" alt="페이스북"
                /></a>
              </li>
              <li>
                <a @click="newPage('https://blog.naver.com/carrotkr6404')"
                  ><img src="@/assets/img/sns3.png" alt="블로그"
                /></a>
              </li>
            </ul>
          </div>
          <div class="family">
            <select class="select" @change="changeSelectBox" v-model="site">
              <option value="">Family Site</option>
              <option value="https://carrotglobal.com/">Carrot HUB</option>
              <option value="https://www.carrotenglish.com/">
                전화영어:모바일 화상
              </option>
              <option value="https://gosiliconvalley.co.kr/">
                실리콘밸리 리더십코스
              </option>
              <option value="https://www.expatcare.co.kr/">
                리:로케이션 서비스
              </option>
              <option value="https://biz.carrotenglish.com/edu-tech">
                온라인ºAI과정
              </option>
              <option value="https://www.how-writing.com/how_intro">
                HOW Writing
              </option>
              <option value="http://www.thespac.net/new/">
                SPAC^ 말하기평가센터
              </option>
              <option value="http://www.thegcat.com/">
                gCAT 글로벌역량진단
              </option>
            </select>
          </div>
        </div>
      </div>
    </footer>

    <!-- 개인정보처리방침, 회원약관 팝업 -->
    <div v-if="popupVisible">
      <template v-if="currentPopup === 'privacy'">
        <Privacy @close="closePopup" />
      </template>
      <template v-else-if="currentPopup === 'terms'">
        <Terms @close="closePopup" />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Privacy from "./Privacy.vue";
import Terms from "./Terms.vue";
export default {
  components: {
    Privacy,
    Terms,
  },
  data() {
    return {
      site: "",
      popupVisible: false, // 개인정보 처리방침, 회원약관 팝업 초기화
      currentPopup: "", // 현재 표시할 팝업 종류
    };
  },
  computed: {
    ...mapGetters(["getTelNo", "getEmail", "getCurrentPath"]),
  },
  methods: {
    changeSelectBox() {
      if (this.site) {
        window.open(this.site, "_blank");
      }
    },
    newPage(path) {
      window.open(path, "_blank");
    },

    // 개인정보 처리방침, 회원약관 팝업
    showPopup(popupType) {
      this.currentPopup = popupType;
      this.popupVisible = true;
    },
    // 팝업 닫기
    closePopup() {
      this.popupVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  background-color: #252525;

  .inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: 14px;
    color: #c0c0c0;

    @media screen and (min-width: 1200px) {
      padding: 50px 20px;
    }

    .left {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding-bottom: 20px;
      border-bottom: 1px solid #c0c0c0;

      a {
        color: #fff;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;

      .sns {
        display: flex;
        align-items: center;
        gap: 10px;

        ul {
          display: flex;
          gap: 5px;
        }
      }

      .family {
        select {
          display: block;
          font-size: 14px;
          color: #c0c0c0;
          appearance: auto;
        }
      }
    }
  }
}
</style>
